import { jdiColorFetch } from '@/apis/colorFetchV2';
import { TERMINAL } from '@/constants/cms';
import type { PageVo, ProductDetailVo } from './land.interface';
import {
  HOME_EVENT_NAMES,
  homeBusinessLogger,
  HOME_TRACK_TYPE,
} from '@/utils/logger/instance/homeBusinessLogger';

const colorHeader = {
  'Content-Type': 'application/x-www-form-urlencoded',
  'X-API-Client': 'pc',
  'X-API-Login-Type': '3',
  'X-API-Platform': 'pc',
  'jnos-product-code': 'b2c',
};
/**
 * 获取新品数据
 * @param params
 * @returns
 */
export const queryNewArrivalSku = (params: {
  cuPage: number;
  pageSize: number;
  mapExInfo?: any;
}): Promise<PageVo<ProductDetailVo>> => {
  return new Promise(async (resolve, reject) => {
    const res = await jdiColorFetch('guide_homepage_getItemFeeds', {
      method: 'POST',
      headers: colorHeader,
      bodyQuery: {
        systemType: 1,
        businessType: 2,
        terminal: TERMINAL.PC,
        type: 'EXT-NEW-ARRIVAL-PRODUCT',
        cuPage: params.cuPage,
        pageSize: params.pageSize,
        params: {
          ...params.mapExInfo,
        },
      },
    });
    if (res.code === '200') {
      resolve(res.data);
    } else {
      reject(res);
    }
  });
};
/**
 * 获取新品数据
 * @param params
 * @returns
 */
export const queryBestSellerSku = (params: {
  cuPage: number;
  pageSize: number;
  mapExInfo?: any;
}): Promise<PageVo<ProductDetailVo>> => {
  return new Promise(async (resolve, reject) => {
    const res = await jdiColorFetch('guide_homepage_getItemFeeds', {
      method: 'POST',
      headers: colorHeader,
      bodyQuery: {
        systemType: 1,
        businessType: 2,
        terminal: TERMINAL.PC,
        type: 'EXT-BEST-SELLER-PRODUCT',
        cuPage: params.cuPage,
        pageSize: params.pageSize,
        params: {
          ...params.mapExInfo,
        },
      },
    });
    if (res.code === 200) {
      resolve(res.data);
    } else {
      reject(res);
    }
  });
};

/**
 * 获取商品数据
 * @param params
 * @returns
 */
export const queryFeeds = (params: {
  type: string;
  cuPage: number;
  pageSize: number;
  mapExInfo?: any;
}): Promise<PageVo<ProductDetailVo>> => {
  return new Promise(async (resolve, reject) => {
    const res = await jdiColorFetch('guide_homepage_getItemFeeds', {
      method: 'POST',
      headers: colorHeader,
      bodyQuery: {
        systemType: 1,
        businessType: 2,
        terminal: TERMINAL.PC,
        type: params.type,
        cuPage: params.cuPage,
        pageSize: params.pageSize,
        params: {
          ...params.mapExInfo,
        },
      },
    });

    if (res.code === '200') {
      resolve(res.data);
    } else {
      homeBusinessLogger({
        eventName: HOME_EVENT_NAMES.CMS_QUERY_FEEDS_ERROR,
        category: {
          type: HOME_TRACK_TYPE.CMS_API_ERROR,
        },
        message: {
          traceId: res.traceId || '-100',
          code: res.code || '-100',
          externalKey: params.type,
          params: {
            ...params.mapExInfo,
          },
        },
      });
      resolve(res?.data);
      // reject(res)
    }
  });
};

/**
 * 领取优惠券
 * @param params
 * @returns
 */
// @ts-ignore
export const getCoupon = async (params) => {
  const res = await jdiColorFetch('guide_homepage_getCoupon', {
    method: 'POST',
    headers: colorHeader,
    bodyQuery: {
      ...params,
    },
  });
  return res;
};
export const getCouponId = async (params: { batchId: number }) => {
  const res = await jdiColorFetch('guide_homepage_getUserCoupon', {
    method: 'POST',
    headers: colorHeader,
    bodyQuery: {
      ...params,
    },
  });
  return res;
};
